/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CardAccountTopupResponseEntryType = typeof CardAccountTopupResponseEntryType[keyof typeof CardAccountTopupResponseEntryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountTopupResponseEntryType = {
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
} as const;
